export const EMPLOYEE_WORK_SUMMARY_EXPORT_COLUMNS = [
  { key: 'name', label: 'Recruiter / TL' },
  { key: 'role', label: 'Role' },
  { key: 'reqsAssigned', label: 'Reqs Assigned' },
  { key: 'profilesSourced', label: 'Profiles Sourced' },
  { key: 'ornnovaScreenSelected', label: 'Ornnova Screen Selected' },
  { key: 'l1Select', label: 'L1' },
  { key: 'l2Select', label: 'L2' },
  { key: 'offerReleased', label: 'Offer Released' },
  { key: 'joined', label: 'Joined' },
  { key: 'declined', label: 'Declined' },
];

export function mapEmployeeWorkSummaryExportRow(row = {}) {
  return {
    name: row.name ?? '',
    role: row.role ?? '',
    reqsAssigned: Number(row.reqsAssigned) || 0,
    profilesSourced: Number(row.profilesSourced) || 0,
    ornnovaScreenSelected: Number(row.ornnovaScreenSelected) || 0,
    l1Select: Number(row.l1Select) || 0,
    l2Select: Number(row.l2Select) || 0,
    offerReleased: Number(row.offerReleased) || 0,
    joined: Number(row.joined) || 0,
    declined: Number(row.declined) || 0,
  };
}

export function buildEmployeeWorkSummaryExportRows(summaryRows = []) {
  return (summaryRows || []).map(mapEmployeeWorkSummaryExportRow);
}
